import { defaultErrorResponse } from "api/defaults";
import { IAppRegistrationSecretExpiration } from "store/environments/environment-types";
import { API } from "utils/api-config";

export const loadAppRegistrationsInfo = async (
    environmentMoniker: string
): Promise<[IAppRegistrationSecretExpiration[] | null, number]> => {
    const response = await API.get(
        `/environments/${environmentMoniker}/azure/app-registrations`
    );

    if (!response) {
        return defaultErrorResponse;
    }

    return [response.data, response.status];
};
